/* unplugin-vue-components disabled */import { render } from "./button.vue?vue&type=template&id=42d7ec62&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=42d7ec62&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d7ec62"],['__file',"src/controls/button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42d7ec62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42d7ec62', __exports__)) {
    api.reload('42d7ec62', __exports__)
  }
  
  module.hot.accept("./button.vue?vue&type=template&id=42d7ec62&scoped=true", () => {
    api.rerender('42d7ec62', render)
  })

}


export default __exports__